import { render, staticRenderFns } from "./BlockSearch.vue?vue&type=template&id=78419392&scoped=true&"
import script from "./BlockSearch.vue?vue&type=script&lang=js&"
export * from "./BlockSearch.vue?vue&type=script&lang=js&"
import style0 from "./BlockSearch.vue?vue&type=style&index=0&id=78419392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78419392",
  null
  
)

export default component.exports